import universal from 'react-universal-component';
import ErrorLoadingRouteChunk from '@client/containers/errorLoadingRouteChunk/ErrorLoadingRouteChunk';
import Loader from 'components/loader/Loader';
import { withRestrictions } from '@client/helperComponents/restrict/withRestrictions';

const options = {
  error: ErrorLoadingRouteChunk,
  loading: Loader,
};

const ROUTES = getCampaignStateRoutes();
const BASE_ROUTE = ROUTES.STATE.TO;
const CHILD_ROUTE = ROUTES.STATE.ROUTES;

export const campaignPageRoutes = {
  path: `${BASE_ROUTE}/:campaignId`,
  exact: false,
  params: {
    campaignId: 'campaignId',
  },
  componentPath: 'pages/campaignPage/CampaignPage',
  Component: withRestrictions({
    shouldBeLoggedIn: true,
  })(
    universal(import('pages/campaignPage/CampaignPage'), options),
    universal(import('pages/loginPage/LoginPage'), options)
  ),
  routes: [
    {
      path: `${BASE_ROUTE}/:campaignId`,
      exact: true,
      params: {
        campaignId: 'campaignId',
      },
      componentPath:
        'pages/campaignPage/campaignDetailsRoute/CampaignOverviewRoute',
      Component: universal(
        import('pages/campaignPage/campaignDetailsRoute/CampaignOverviewRoute'),
        options
      ),
    },
    {
      path: `${BASE_ROUTE}/:campaignId${CHILD_ROUTE.DETAILS.TO}`,
      exact: true,
      params: {
        campaignId: 'campaignId',
      },
      componentPath:
        'pages/campaignPage/campaignDetailsRoute/CampaignOverviewRoute',
      Component: universal(
        import('pages/campaignPage/campaignDetailsRoute/CampaignOverviewRoute'),
        options
      ),
    },
    {
      path: `${BASE_ROUTE}/:campaignId${CHILD_ROUTE.APPLIED.TO}*`,
      exact: true,
      params: {
        campaignId: 'campaignId',
      },
      componentPath:
        'pages/campaignPage/campaignAppliedRoute/CampaignAppliedRoute',
      Component: universal(
        import('pages/campaignPage/campaignAppliedRoute/CampaignAppliedRoute'),
        options
      ),
    },
    {
      path: `${BASE_ROUTE}/:campaignId${CHILD_ROUTE.SHORTLISTED.TO}`,
      exact: true,
      params: {
        campaignId: 'campaignId',
      },
      componentPath:
        'pages/campaignPage/campaignShortListedRoute/CampaignShortListedRoute',
      Component: universal(
        import(
          'pages/campaignPage/campaignShortListedRoute/CampaignShortListedRoute'
        ),
        options
      ),
    },
    {
      path: `${BASE_ROUTE}/:campaignId${CHILD_ROUTE.APPROVED.TO}`,
      exact: true,
      params: {
        campaignId: 'campaignId',
      },
      componentPath:
        'pages/campaignPage/campaignApprovedRoute/CampaignApprovedRoute',
      Component: universal(
        import(
          'pages/campaignPage/campaignApprovedRoute/CampaignApprovedRoute'
        ),
        options
      ),
    },
    {
      path: `${BASE_ROUTE}/:campaignId${CHILD_ROUTE.DRAFTS.TO}`,
      exact: true,
      params: {
        campaignId: 'campaignId',
      },
      componentPath:
        'pages/campaignPage/campaignDraftsRoute/CampaignDraftsRoute',
      Component: universal(
        import('pages/campaignPage/campaignDraftsRoute/CampaignDraftsRoute'),
        options
      ),
    },
    {
      path: `${BASE_ROUTE}/:campaignId${CHILD_ROUTE.POSTS.TO}*`,
      exact: true,
      params: {
        campaignId: 'campaignId',
      },
      componentPath: 'pages/campaignPage/campaignPostsRoute/CampaignPostsRoute',
      Component: universal(
        import('pages/campaignPage/campaignPostsRoute/CampaignPostsRoute'),
        options
      ),
    },
  ],
};

export function getCampaignStateRoutes(userRestrictions) {
  let routes = {
    STATE: {
      TO: '/admin/campaign',
      LABEL: 'CAMPAIGN STATE',
      RESTRICTIONS: {
        SHOULD_BE_LOGGED_IN: false,
      },
      ROUTES: {
        DETAILS: {
          TO: '/details',
          LABEL: 'DETAILS',
          RESTRICTIONS: {
            SHOULD_BE_LOGGED_IN: false,
          },
        },
        APPLIED: {
          TO: '/applied',
          LABEL: 'APPLIED',
          RESTRICTIONS: {
            SHOULD_BE_LOGGED_IN: false,
          },
        },
        SHORTLISTED: {
          TO: '/short-listed',
          LABEL: 'SHORTLISTED',
          RESTRICTIONS: {
            SHOULD_BE_LOGGED_IN: false,
          },
        },
        APPROVED: {
          TO: '/approved',
          LABEL: 'APPROVED',
          RESTRICTIONS: {
            SHOULD_BE_LOGGED_IN: false,
          },
        },
        DRAFTS: {
          TO: '/drafts',
          LABEL: 'DRAFTS',
          RESTRICTIONS: {
            SHOULD_BE_LOGGED_IN: false,
          },
        },
        POSTS: {
          TO: '/posts',
          LABEL: 'POSTS',
          RESTRICTIONS: {
            SHOULD_BE_LOGGED_IN: false,
          },
        },
      },
    },
  };

  if (!userRestrictions) {
    return routes;
  } else {
    // Remove restricted routes
    return routes;
  }
}
